import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

export interface ReportePVRow {
  id_dia: number;
  id_punto_venta: number;
  fecha: string;
  fecha_inicial: string;
  nombre: string;
  tipo: string;
  cantidad: number;
  monto_total: number;
}

export async function getReportePuntoVenta(ids_dia: number[]): Promise<ReportePVRow[]> {
  try {
    const response = await axios.get(`${API_URL}puntoVenta/reporte`, {
      params: { ids_dia: ids_dia.join(',') },
    });
    return response.data?.doc?.data ?? [];
  } catch (error) {
    console.error('Error fetching reporte puntos de venta:', error);
    throw error;
  }
}
